import { render, staticRenderFns } from "./LandingHtmlPage.vue?vue&type=template&id=33afcce2&scoped=true"
import script from "./LandingHtmlPage.vue?vue&type=script&lang=js"
export * from "./LandingHtmlPage.vue?vue&type=script&lang=js"
import style0 from "./LandingHtmlPage.vue?vue&type=style&index=0&id=33afcce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33afcce2",
  null
  
)

export default component.exports